
import SectionStage from '@/sections/SectionStage.vue'
export default {
  components: { SectionStage },
  layout() {
    return 'error'
  },
  props: {
    error: {
      type: Object,
      required: true
    }
  },
  computed: {
    language() {
      return this.$store.getters['language']
    },
    errorDataSet() {
      if (!this.error) {
        return {
          generic: {
            headline: 'Error 501',
            description:
              this.language == 'de'
                ? 'Uups, Etwas ist schief gelaufen.'
                : 'Uups, Something went wrong.',
            button_text:
              this.language == 'de'
                ? 'Zurück zur Homepage'
                : 'Back to homepage',
            button_link: '/'
          }
        }
      }
      return {
        generic: {
          headline: `Error ${this.error.statusCode}`,
          description: this.error.message,
          button_text:
            this.language == 'de' ? 'Zurück zur Homepage' : 'Back to homepage',
          button_link: '/'
        }
      }
    }
  },
  created() {
    if (process.client) {
      this.pushMetaEvent()
      this.pushErrorEvent()
      // this.addGTM()
    }
  },
  mounted() {}
}
